import styled from 'styled-components'

export const StepTitle = styled.div`
	padding: 12px 8px 12px 0;
	text-align: left;
	font-size: 120%;
	flex: 0;
`
